import { LifeRingTrigger } from 'components/ActionBar/LifeRing/LifeRingButton/LifeRingButton';
import { ConnectedBackToBackWorkflow } from 'components/common-form/sidePanel/actions/trade/backToBack/BackToBackWorkflow';
import { TopTabContent } from 'components/common-form/sidePanel/topTabs/TopTabContent';
import { ConnectedHelpCenterButton } from 'components/shared/HelpCenter/HelpCenterButton';
import { useToggleFeature } from 'hooks/useToggleFeature';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { AddonQuoteAction, TradeActions } from './action';
import { TradeComment } from './action/TradeComment';
import { TradeDoneButton } from './action/tradeDone';
import { ConnectedPriceEnhancerForPostTrade } from './infos/priceEnhancement/PriceEnhancement.connect';
import { QuoteInfos } from './infos/QuoteDetails';
import type { ContentProps } from './MainContent.connect';
import { connectContent } from './MainContent.connect';
import { ValidationErrors } from './status';

const Component: FC<ContentProps> = ({
  className,
  hasPriceEnhancer,
  hasQuoteButtons,
  hasTradeButtons,
  hasTradeDoneButton,
  hasValidationErrors,
  tabId,
  quoteId,
  isRejected,
  hasBackToBack,
}) => {
  const helpCenterEnhancement = useToggleFeature('helpCenterEnhancement');
  const workspaceType = 'postTrade';

  return (
    <TopTabContent
      className={className}
      header={
        <div id="side-panel-header" data-e2e="side-panel-header">
          {hasValidationErrors && (
            <ValidationErrors tabId={tabId} onlyErrorsDisplayedInSummary errorPrefix="quote.errorMessages." />
          )}
          {hasPriceEnhancer && (
            <ConnectedPriceEnhancerForPostTrade tabId={tabId} quoteId={quoteId!} workspaceType={workspaceType} />
          )}
          {hasPriceEnhancer && <TradeComment tabId={tabId} />}
          {hasTradeButtons && hasBackToBack && (
            <ConnectedBackToBackWorkflow quoteId={quoteId!} formId={tabId} workspace={workspaceType} />
          )}
        </div>
      }
      body={<QuoteInfos tabId={tabId} workspaceType={workspaceType} />}
      footer={
        <>
          {isRejected && helpCenterEnhancement && (
            <div className="d-flex w-100 mb-2">
              <ConnectedHelpCenterButton helpCenterId={'AddonSidePanel'} />
            </div>
          )}
          {isRejected && !helpCenterEnhancement && (
            <LifeRingTrigger e2e="SecondaryPanelContactUs-button" className={'d-flex w-100'}>
              <button type="button" className="btn btn-default btn-xl m-1 w-100">
                <FormattedMessage id="lifeRing.helpRequest" />
                <em className="icon icon-outlined ms-1">live_help</em>
              </button>
            </LifeRingTrigger>
          )}

          {hasQuoteButtons && <AddonQuoteAction tabId={tabId} />}
          {hasTradeButtons && <TradeActions tabId={tabId} workspaceType={workspaceType} />}
          {hasTradeDoneButton && <TradeDoneButton tabId={tabId} className="w-100" />}
        </>
      }
    />
  );
};

export const MainContent = connectContent(Component);
MainContent.displayName = 'AddonSidePanelContent';
